import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from "antd";
export const H1 = (props) => (_jsx(Typography.Title, { level: 1, ...props }));
export const H2 = (props) => (_jsx(Typography.Title, { level: 2, ...props }));
export const H3 = (props) => (_jsx(Typography.Title, { level: 3, ...props }));
export const H4 = (props) => (_jsx(Typography.Title, { level: 4, ...props }));
export const H5 = (props) => (_jsx(Typography.Title, { level: 5, ...props }));
const Paragraph = Typography.Paragraph;
export { Paragraph as P };
export const Strong = (props) => (_jsx(Typography.Text, { strong: true, ...props }));
//# sourceMappingURL=Text.js.map